import { render, staticRenderFns } from "./reports.vue?vue&type=template&id=38ac55f4&scoped=true&"
import script from "./reports.vue?vue&type=script&lang=js&"
export * from "./reports.vue?vue&type=script&lang=js&"
import style0 from "./reports.vue?vue&type=style&index=0&id=38ac55f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac55f4",
  null
  
)

export default component.exports